// biome-ignore-all lint/suspicious/noConsole: carried over from the ESLint suppression
type LogContext<T = unknown> = {
  [key: string]: T | LogContext<T>;
};

type LogMessage = (message: string, context?: LogContext) => void;
type LogError = (message: string, error: Error, context?: LogContext) => void;

interface Logger {
  error: LogError;
  info: LogMessage;
  warn: LogMessage;
}

const logInfo: LogMessage = (message: string, context?: LogContext) => {
  console.log(message, context);
};

const logWarning: LogMessage = (message: string, context?: LogContext) => {
  console.warn(message, context);
};

const logError: LogError = (message: string, error: Error, context?: LogContext) => {
  console.error(message ?? error.message, {
    error,
    context,
  });
};

const logger = (): Logger => ({
  error: logError,
  info: logInfo,
  warn: logWarning,
});

export const loggerService = logger();
